import ErrorTooltip from 'Components/ErrorTooltip';
import ReportingFileUpload from 'Components/ReportingFileUpload';
import ToolTip from 'Components/ToolTip';
import { TooltipMsg } from 'Components/ToolTipMessage';
import { Field, FieldProps, useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';
import { Card, CardHeader, Row, Col, CardBody, Label, Input } from 'reactstrap';
import { ReportingEvents, FileStatus } from 'shared/constants';
import { queryKeyes } from 'shared/queryKeys';
import env from 'environment_system/env_system';
import { RootState } from 'index';
import { useSelector } from 'react-redux';
import { checkValidArray } from 'GenericForms/Helper';
import { useEditReport } from 'VesselReportingInfo/EditCompletedReports/EditReportProvider';

interface ReeferContainerProps {
  alertBool: boolean;
  deleteBaplieFileObj: any;
  setRefreshKey: any;
  refreshKey: number;
  baplieFiles: any[];
  setBaplieFiles: any;
  deleteLogBookObj: any;
  logBook: any[];
  setLogBook: any;
  cargoChange: string;
  previousReeferDetails: boolean;
  containerChangePopupBool: boolean
  calculateTotalCargoOnboard: any;
  containerChangeState: string;
  editValues: any;
  setEditValues: any;
  editReportBool: boolean;
}
const ReeferContainerComponent = ({
  alertBool,
  deleteBaplieFileObj,
  setRefreshKey,
  refreshKey,
  baplieFiles,
  setBaplieFiles,
  deleteLogBookObj,
  logBook,
  setLogBook,
  previousReeferDetails,
  containerChangePopupBool,
  calculateTotalCargoOnboard,
  containerChangeState,
  editValues,
  setEditValues,
  editReportBool
}: ReeferContainerProps) => {
  /** State variables */
  const {
    values,
    errors,
    handleChange,
    handleBlur,
    setFieldValue,
    setValues,
    touched
  }: { values: any; errors: any; handleChange: any; handleBlur: any, setFieldValue: any, setValues: any, touched: any } =
    useFormikContext<any>();
  const { discardwarning } = useEditReport();
  const [refresh, setRefresh] = useState(0);
  const { CurrentReport, PreviousReport, CurrentReportFiles } = useSelector((state: RootState) => state.Reporting);
  const currentVesselReport = CurrentReport?.data?.vessel_reporting_information ?? null;
  const reeferContainerDetailsPreviousReport = PreviousReport?.data?.deck_officer?.reefer_container_details ?? null;
  const reeferContainerFiles = checkValidArray(CurrentReportFiles?.ReeferContainer) ? CurrentReportFiles?.ReeferContainer[0] : [];
  /** State variables end */

  /** UseEffect */
  useEffect(() => {
    if (containerChangeState === "no") {
      setValues({
        ...values,
        reefer_container_details: {
          ...values?.reefer_container_details,
          reason_for_change: reeferContainerDetailsPreviousReport?.reason_for_change,
          loaded_container: 0,
          discharged_container: 0,
          total_onboard_container: reeferContainerDetailsPreviousReport?.total_onboard_container,
          feet_20: reeferContainerDetailsPreviousReport?.feet_20,
          feet_40: reeferContainerDetailsPreviousReport?.feet_40,
        }
      });
      setRefresh(refresh + 1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [containerChangeState])
  useEffect(() => {
    if (editValues && editValues?.deck_officer?.reefer_container_details?.id > 0) {
      setEditValues({
        ...editValues,
        vessel_reporting_information: {
          ...editValues?.vessel_reporting_information,
          change_in_containers_onboard: containerChangeState,
        },
        deck_officer: {
          ...editValues?.deck_officer,
          reefer_container_details: values?.reefer_container_details
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values?.reefer_container_details])
  /** UseEffect end */
  return (
    <Card className="p-0 mb-0 rounded-0 border-start-0 border-end-0">
      <CardHeader className="py-2 px-0">
        <div className="text-center">
          <Row>
            <Col>
              <h4 className="page_title pos-start mb-0">Reefer Containers</h4>
              <p className="card-title-desc pos-start">
                All readings since last report
              </p>
            </Col>
          </Row>
        </div>
      </CardHeader>
      <CardBody className="px-0 py-0 mt-2">
        <Row className='mb-2'>
          <div className='ele_row1 d-flex gap-3'>
            <div>
              <Label for="no_of_reefer_containers_loaded" className="mb-0 asteric">
                Containers loaded
                <i
                  className="bx bx-info-circle ml-2p"
                  id="no_of_reefer_containers_loaded_msg"
                />
              </Label>
              <ToolTip
                target="no_of_reefer_containers_loaded_msg"
                message={`${TooltipMsg.Reefer_Container.filter(
                  (item: any) =>
                    item.target === 'no_of_reefer_containers_loaded_msg',
                ).map((tool: any) => {
                  return tool.message;
                })}`}
              />
              <div className="input-group">
                <Field name="reefer_container_details.loaded_container">
                  {({ field }: FieldProps) => (
                    <>
                      <Input
                        onFocus={(e) => e.target.select()}
                        key={refresh}
                        type="text"
                        className={`form-control text-right max-width-7
                          ${previousReeferDetails && "cursor-not-allowed"}`}
                        id="no_of_reefer_containers_loaded"
                        {...field}
                        value={field.value ?? ""}
                        disabled={previousReeferDetails}
                      />
                      <div className="input-group-text round_border">TEU</div>
                    </>
                  )}
                </Field>
                {errors?.reefer_container_details &&
                  touched?.reefer_container_details &&
                  errors?.reefer_container_details?.loaded_container &&
                  touched?.reefer_container_details.loaded_container &&
                  !alertBool && !containerChangePopupBool && !previousReeferDetails &&
                  env?.form_validation === true && !discardwarning && (
                    <ErrorTooltip
                      target="no_of_reefer_containers_loaded"
                      message={errors?.reefer_container_details?.loaded_container}
                      open={
                        errors?.reefer_container_details &&
                          touched?.reefer_container_details &&
                          errors?.reefer_container_details?.loaded_container &&
                          touched?.reefer_container_details.loaded_container
                          ? true
                          : false
                      }
                    />
                  )}
              </div>
            </div>
            <div>
              <Label for="no_of_reefer_containers_discharged" className="mb-0 asteric">
                Containers discharged
                <i
                  className="bx bx-info-circle ml-2p"
                  id="no_of_reefer_containers_discharged_msg"
                />
              </Label>
              <ToolTip
                target="no_of_reefer_containers_discharged_msg"
                message={`${TooltipMsg.Reefer_Container.filter(
                  (item: any) =>
                    item.target === 'no_of_reefer_containers_discharged_msg',
                ).map((tool: any) => {
                  return tool.message;
                })}`}
              />
              <div className="input-group">
                <Field name="reefer_container_details.discharged_container">
                  {({ field }: FieldProps) => (
                    <>
                      <Input
                        onFocus={(e) => e.target.select()}
                        key={refresh}
                        type="text"
                        className={`form-control text-right max-width-7
                          ${previousReeferDetails && "cursor-not-allowed"}`}
                        id="no_of_reefer_containers_discharged"
                        {...field}
                        value={field.value ?? ""}
                        disabled={previousReeferDetails}
                      />
                      <div className="input-group-text round_border">TEU</div>
                    </>
                  )}
                </Field>
                {errors?.reefer_container_details &&
                  touched?.reefer_container_details &&
                  touched?.reefer_container_details.discharged_container &&
                  errors?.reefer_container_details?.discharged_container &&
                  !alertBool && !containerChangePopupBool && !previousReeferDetails &&
                  env?.form_validation === true && !discardwarning && (
                    <ErrorTooltip
                      target="no_of_reefer_containers_discharged"
                      message={
                        errors?.reefer_container_details?.discharged_container
                      }
                      open={
                        errors?.reefer_container_details &&
                          touched?.reefer_container_details &&
                          touched?.reefer_container_details.discharged_container &&
                          errors?.reefer_container_details?.discharged_container
                          ? true
                          : false
                      }
                    />
                  )}
              </div>
            </div>
            <div>
              <Label for="total_reefer_containers_onboard" className="mb-0 asteric">
                Total containers onboard
                <i
                  className="bx bx-info-circle ml-2p"
                  id="total_reefer_containers_onboard_msg"
                />
              </Label>
              <ToolTip
                target="total_reefer_containers_onboard_msg"
                message={`${TooltipMsg.Reefer_Container.filter(
                  (item: any) =>
                    item.target === 'total_reefer_containers_onboard_msg',
                ).map((tool: any) => {
                  return tool.message;
                })}`}
              />
              <div className="input-group">
                <Field
                  key={refresh}
                  type="text"
                  className="form-control text-right max-width-7 cursor-not-allowed"
                  name="reefer_container_details.total_onboard_container"
                  id="total_reefer_containers_onboard"
                  disabled
                />
                <div className="input-group-text round_border">TEU</div>
                {errors?.reefer_container_details &&
                  errors?.reefer_container_details?.total_onboard_container &&
                  !alertBool && !containerChangePopupBool && !previousReeferDetails &&
                  env?.form_validation === true && !discardwarning && (
                    <ErrorTooltip
                      target="total_reefer_containers_onboard"
                      message={
                        errors?.reefer_container_details?.total_onboard_container
                      }
                      open={
                        errors?.reefer_container_details &&
                          errors?.reefer_container_details?.total_onboard_container
                          ? true
                          : false
                      }
                    />
                  )}
              </div>
            </div>
            <div>
              <Label for="reason_for_change" className="mb-0 asteric">
                Reason for change in number of containers onboard
                <i
                  className="bx bx-info-circle ml-2p"
                  id="reason_for_change_msg"
                />
              </Label>
              <ToolTip
                target="reason_for_change_msg"
                message={`${TooltipMsg.Reefer_Container.filter(
                  (item: any) => item.target === 'reason_for_change_msg',
                ).map((tool: any) => {
                  return tool.message;
                })}`}
              />
              <Field name="reefer_container_details.reason_for_change">
                {() => (
                  <textarea
                    key={refresh}
                    className={`form-control max-width-13
                          ${previousReeferDetails && "cursor-not-allowed"}`}
                    name="reefer_container_details.reason_for_change"
                    id="reason_for_change"
                    rows={values?.reefer_container_details?.reason_for_change?.toString()?.length < 10 ? 1 : 2}
                    onChange={(e: any) => handleChange(e)}
                    onBlur={(e: any) => {
                      handleChange(e);
                      handleBlur(e);
                    }}
                    defaultValue={
                      values?.reefer_container_details?.reason_for_change
                    }
                    disabled={previousReeferDetails}
                  />
                )}
              </Field>
              {errors?.reefer_container_details &&
                errors?.reefer_container_details?.reason_for_change &&
                !alertBool && !containerChangePopupBool && !previousReeferDetails &&
                env?.form_validation === true && !discardwarning && (
                  <ErrorTooltip
                    target="reason_for_change"
                    message={errors?.reefer_container_details?.reason_for_change}
                    open={
                      errors?.reefer_container_details &&
                        errors?.reefer_container_details?.reason_for_change
                        ? true
                        : false
                    }
                  />
                )}
            </div>
          </div>
        </Row>
        <Row className="mb-2">
          <Col sm={2}>
            <Label className="mb-0 asteric" for="feet_20">
              20 ft units
              <i
                className="bx bx-info-circle ml-2p"
                id="referContainer_feet_20_msg"
              />
            </Label>
            <ToolTip
              target="referContainer_feet_20_msg"
              message={`${TooltipMsg.Draft_and_Displacement.filter(
                (item: any) => item.target === 'feet_20_msg',
              ).map((tool: any) => {
                return tool.message;
              })}`}
            />
            <div className="input-group">
              <Field name="reefer_container_details.feet_20">
                {({ field }: FieldProps) => (
                  <Input
                    onFocus={(e) => e.target.select()}
                    key={refresh}
                    type="text"
                    className={`form-control text-right ${previousReeferDetails && "cursor-not-allowed"}`}
                    id="referContainer_feet_20"
                    name={field.name}
                    onBlur={(e: any) => {
                      handleBlur(e);
                      handleChange(e);
                      calculateTotalCargoOnboard(
                        parseFloat(e.target.value ?? 0),
                        parseFloat(values?.reefer_container_details?.feet_40 ?? 0),
                        setFieldValue,
                        "reefer_container_details.total_onboard_container"
                      );
                    }}
                    onChange={(e: any) => {
                      handleBlur(e);
                      handleChange(e);
                      calculateTotalCargoOnboard(
                        parseFloat(e.target.value ?? 0),
                        parseFloat(values?.reefer_container_details?.feet_40 ?? 0),
                        setFieldValue,
                        "reefer_container_details.total_onboard_container"
                      );
                    }}
                    defaultValue={values.reefer_container_details.feet_20}
                    disabled={previousReeferDetails}
                  />
                )}
              </Field>
              <div className="input-group-text round_border">Nos</div>
            </div>
            {errors?.reefer_container_details &&
              touched?.reefer_container_details?.feet_20 &&
              errors?.reefer_container_details?.feet_20 &&
              !alertBool && !containerChangePopupBool && !previousReeferDetails &&
              env?.form_validation === true && !discardwarning && (
                <ErrorTooltip
                  target="referContainer_feet_20"
                  message={errors?.reefer_container_details?.feet_20}
                  open={
                    errors?.reefer_container_details &&
                      errors?.reefer_container_details?.feet_20
                      ? true
                      : false
                  }
                />
              )}
          </Col>
          <Col sm={2}>
            <Label className="mb-0 asteric" for="feet_40">
              40 ft units
              <i
                className="bx bx-info-circle ml-2p"
                id="referContainer_feet_40_msg"
              />
            </Label>
            <ToolTip
              target="referContainer_feet_40_msg"
              message={`${TooltipMsg.Draft_and_Displacement.filter(
                (item: any) => item.target === 'feet_40_msg',
              ).map((tool: any) => {
                return tool.message;
              })}`}
            />
            <div className="input-group">
              <Field name="reefer_container_details.feet_40">
                {({ field }: FieldProps) => (
                  <Input
                    onFocus={(e) => e.target.select()}
                    key={refresh}
                    type="text"
                    className={`form-control text-right ${previousReeferDetails && "cursor-not-allowed"}`}
                    id="referContainer_feet_40"
                    name={field.name}
                    onBlur={(e: any) => {
                      handleBlur(e);
                      handleChange(e);
                      calculateTotalCargoOnboard(
                        parseFloat(values?.reefer_container_details?.feet_20 ?? 0),
                        parseFloat(e.target.value ?? 0),
                        setFieldValue,
                        "reefer_container_details.total_onboard_container"
                      );
                    }}
                    onChange={(e: any) => {
                      handleBlur(e);
                      handleChange(e);
                      calculateTotalCargoOnboard(
                        parseFloat(values?.reefer_container_details?.feet_20 ?? 0),
                        parseFloat(e.target.value ?? 0),
                        setFieldValue,
                        "reefer_container_details.total_onboard_container"
                      );
                    }}
                    defaultValue={values.reefer_container_details.feet_40}
                    disabled={previousReeferDetails}
                  />
                )}
              </Field>
              <div className="input-group-text round_border">Nos</div>
            </div>
            {errors?.reefer_container_details &&
              touched?.reefer_container_details?.feet_40 &&
              errors?.reefer_container_details?.feet_40 &&
              !alertBool && !containerChangePopupBool && !previousReeferDetails &&
              env?.form_validation === true && !discardwarning && (
                <ErrorTooltip
                  target="referContainer_feet_40"
                  message={errors?.reefer_container_details?.feet_40}
                  open={
                    errors?.reefer_container_details &&
                      errors?.reefer_container_details?.feet_40
                      ? true
                      : false
                  }
                />
              )}
          </Col>
        </Row>
        {currentVesselReport?.reporting_event === ReportingEvents.DEPARTURE_FROM_BERTH && !editReportBool && (
          <Row className="py-1">
            <ReportingFileUpload
              setFile={setBaplieFiles}
              file={baplieFiles}
              fileUploadStatus={
                reeferContainerFiles?.baplie_file_status ===
                FileStatus.UPLOADED
              }
              fileURL={reeferContainerFiles?.baplie_file_path}
              deleteURL={`/reefer_container_details/`}
              invalidateQuery={
                queryKeyes.vessel.ReeferContainerDetailsObject.key
              }
              deleteID={reeferContainerFiles?.id}
              refreshKey={refreshKey}
              setRefreshKey={setRefreshKey}
              title={'Baplie File'}
              DeleteFileObj={deleteBaplieFileObj}
              index={0}
            />
          </Row>
        )}
        {(parseInt(values?.reefer_container_details?.feet_20) !== reeferContainerDetailsPreviousReport?.feet_20 ||
          parseInt(values?.reefer_container_details?.feet_40) !== reeferContainerDetailsPreviousReport?.feet_40
        ) && !editReportBool &&
          <Row className="py-1">
            <ReportingFileUpload
              setFile={setLogBook}
              file={logBook}
              fileUploadStatus={
                reeferContainerFiles?.log_book_status ===
                FileStatus.UPLOADED
              }
              fileURL={reeferContainerFiles?.log_book_path}
              deleteURL={`/reefer_container_details/`}
              invalidateQuery={null}
              deleteID={reeferContainerFiles?.id}
              refreshKey={refreshKey}
              setRefreshKey={setRefreshKey}
              title={'Log Book Upload'}
              DeleteFileObj={deleteLogBookObj}
              index={1}
            />
          </Row>
        }
      </CardBody>
    </Card>
  );
};

export default ReeferContainerComponent;
